export type PeriodeGrade = {
  master_periode_grade_id: number;
  master_periode_id: number;
  grade: number;
  nilai_max: number;
  nilai_min: number;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
};

export type PeriodeGradeResponse = {
  datas: PeriodeGrade[];
  is_next: boolean;
  status: string;
};

import { apiClient } from "@/lib/api-client";

export const fetchPeriodeGrade = async ({ pageParam = 1 }: { pageParam?: number } = {}): Promise<PeriodeGradeResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  return apiClient<PeriodeGradeResponse>(`${baseUrl}/api/v1/master-periode-grade?page=${pageParam}`);
};
